import { InveniasEntityTypes, InveniasFileTypes, InveniasListTypes, InveniasNamespace } from 'datasource-service-lib';
import { IWorkflowService } from 'interfaces-lib';
import { IPreMergeChecker } from '../../interfaces/ipremergechecker';
import { IMergeBasketViewConfig } from '../../merge-basket-view/merge-basket-view.component';
import { ServiceProviderService } from '../service.provider.service';
import { InveniasFileToPathConverter } from './invenias.filetopathconverter';
import { InveniasPreMergeCheck } from './invenias.premergecheck';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';

export class InveniasMergeBasketViewConfig implements IMergeBasketViewConfig {
  readonly namespace = InveniasNamespace.name;
  readonly workflowService: IWorkflowService;
  readonly entityType = InveniasEntityTypes.People;
  readonly fileType = InveniasFileTypes.Document;
  readonly fileToPathConverter = new InveniasFileToPathConverter(InveniasListTypes.Documents);
  readonly preMergeChecker: IPreMergeChecker;

  constructor(serviceProviderService: ServiceProviderService, sharedServiceProvider: SharedServiceProviderServiceFactory) {
    this.workflowService = serviceProviderService.getWorkflowService(InveniasNamespace.name);
    this.preMergeChecker = new InveniasPreMergeCheck(serviceProviderService, sharedServiceProvider);
  }
}
